import { render, staticRenderFns } from "./HanoiVip.vue?vue&type=template&id=3636c9a6&"
import script from "./HanoiVip.vue?vue&type=script&lang=js&"
export * from "./HanoiVip.vue?vue&type=script&lang=js&"
import style0 from "./HanoiVip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports